import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import router from "@/router";
import User from "@/model/user";
import AdminUser from "@/model/adminUser";
import CustomerUser from "@/model/customerUser";
import { ADMIN_TYPE, CUSTOMER_TYPE } from "@/common/constant";
import store from "@/store";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  token = sessionStorage.getItem("token") || "";
  authenticate_status = "";
  expired_at = "";
  user_type = "";
  isOpen = false;
  userLogging: User;
  admin_user: AdminUser = null;
  customer_user: CustomerUser = null;
  is_login_time = false;

  @Mutation
  setAuthenticateStatus(status: string): void {
    this.authenticate_status = status;
  }
  @Mutation
  setToken(token: string): void {
    this.token = token;
    sessionStorage.setItem("token", token);
  }
  @Mutation
  setExpiredAt(time: string): void {
    this.expired_at = time;
  }
  @Mutation
  setUserType(userType: string): void {
    this.user_type = userType;
  }
  @Mutation
  setUserLogging(user: any): void {
    if (this.user_type == ADMIN_TYPE) {
      this.customer_user = null;
      this.admin_user = new AdminUser(user);
    } else if (this.user_type == CUSTOMER_TYPE) {
      this.admin_user = null;
      this.customer_user = new CustomerUser(user);
    }
  }
  @Mutation
  setAdminUser(user: AdminUser): void {
    this.admin_user = user ? new AdminUser(user) : null;
  }

  @Mutation
  setCustomerUser(user: CustomerUser): void {
    this.customer_user = user ? new CustomerUser(user) : null;
  }
  @Mutation
  setIsOpen(status: boolean): void {
    this.isOpen = status;
  }

  @Mutation
  setIsLoginTime(isLoginTime: boolean): void {
    this.is_login_time = isLoginTime;
  }

  @Action({ rawError: true })
  updateAuthenticateStatus(status: string): void {
    this.context.commit("setAuthenticateStatus", status);
  }
  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  updateUserType(userType: string): void {
    this.context.commit("setUserType", userType);
  }

  @Action
  async fetchCurrentUser(user: any): Promise<void> {
    this.context.commit("setUserLogging", user);
  }
  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }

  @Action
  updateIsOpen(status: boolean): void {
    this.context.commit("setIsOpen", status);
  }

  @Action
  updateIsLoginTime(isLoginTime: boolean): void {
    this.context.commit("setIsLoginTime", isLoginTime);
  }

  @Action
  logout(): void {
    this.context.commit("setToken", "");
    this.context.commit("setUserType", "");
    this.context.commit("setAdminUser", null);
    this.context.commit("setCustomerUser", null);
    this.context.commit("setIsLoginTime", false);
    store.dispatch("Router/setSearchParameters", null);
    router.push({ name: "login" });
  }

  get getAuthenticateStatus(): string {
    return this.authenticate_status;
  }
  get getExpiredAt(): string {
    return this.expired_at;
  }
  get getUserType(): string {
    return this.user_type;
  }

  get getUserLogging(): any {
    return this.user_type == ADMIN_TYPE ? this.admin_user : this.customer_user;
  }

  get getAdminUser(): AdminUser {
    return this.admin_user;
  }
  get getCustomerUser(): CustomerUser {
    return this.customer_user;
  }
  get getToken(): string {
    return this.token;
  }

  get loggingName(): string {
    if (this.user_type == ADMIN_TYPE) {
      return this.admin_user.administrator_name;
    } else if (this.customer_user.m_cart_customer) {
      return `${this.customer_user.m_cart_customer.customer_name}　${this.customer_user.account_supervisor_name}`;
    }
  }

  get isCustomer(): boolean {
    return this.user_type == CUSTOMER_TYPE;
  }

  get getIsOpen(): boolean {
    return this.isOpen;
  }

  get isLoginTime(): boolean {
    return this.is_login_time;
  }
}

// export default getModule(AuthModule);
